import { loginPostFailed, loginPostSuccess, onSignUpCheckEmailError, onSignUpCheckEmailSuccess, registerPostFailed, registerPostSuccess } from '../actions/creators/auth';
import { userSessionsFetch } from '../actions/creators/user';
import * as actions from '../actions/types';
import CMX from '../api';
import { getFingerprint, getLoginEmail, getLoginPassword, getUserSignUpPaymentResult } from '../reducers';
import { onApiError } from './misc';
import { CHECKOUT_CONTEXT_SIGN_UP } from '../actions/creators/checkout';
import { addReferralToParams, REFERRAL_SCOPES } from '../utils/referral';

export const authMiddleware = ({ getState, dispatch }) => next => async action => {
    next(action);

    switch (action.type) {
        case actions.AUTH_SIGN_UP_CHECK_EMAIL_SUBMIT:
            return onSignUpCheckEmailSubmit(action, dispatch, getState);
        case actions.AUTH_SIGN_UP_CHECK_EMAIL_ERROR:
            return onApiError(dispatch, action);
        case actions.AUTH_LOGIN_POST_ERROR:
            return onLoginError(dispatch, action);
        case actions.AUTH_LOGIN_POST:
        case actions.AUTH_LOGIN_PIN_POST:
            return onLoginPost(getState, dispatch, action);
        case actions.AUTH_LOGOUT:
            return onLogOut(dispatch);
        case actions.AUTH_LOGOUT_SUCCESS:
            return setTimeout(() => document.location.href = '/', 2000);
        case actions.USER_SESSION_KILL_SUCCESS:
            return dispatch(userSessionsFetch());
        case actions.AUTH_RENEW_TOKEN:
            return renewAuthToken(action, getState, dispatch);
        case actions.AUTH_REGISTER_POST:
            return onRegisterPost(getState, dispatch, action);
        case actions.AUTH_REGISTER_POST_ERROR:
            return onApiError(dispatch, action);
        case actions.CHECKOUT_PAYMENT_SUCCESS:
            return onCheckoutPaymentSuccess(action, getState, dispatch);
        case actions.AUTH_CLOSE:
            return onAuthClose();
        default:
            return;
    }
};

function onSignUpCheckEmailSubmit(action, dispatch, getState) {
    const params = {
        email: action.email,
        captcha: action.captcha
    };

    if (('auth_pin' in action)) params.auth_pin = action.auth_pin;

    return CMX.post('/register', params)
        .then(res => dispatch(onSignUpCheckEmailSuccess(res)))
        .catch(error => dispatch(onSignUpCheckEmailError(error, action)));
}

function onLoginPost(getState, dispatch, action) {
    const state = getState();
    const fingerprint = getFingerprint(state);
    const args = {fingerprint};

    if ('apple_signin' in action) {
        args.apple_signin = action.apple_signin;
    } else {    
        args.email = getLoginEmail(state);
        args.password = getLoginPassword(state);
    }

    if (action.pin) args.pin = action.pin;

    CMX.post('/login', args)
        .then(data => dispatch(loginPostSuccess(data)))
        .catch(error => dispatch(loginPostFailed(error)));
}

function onLoginError(dispatch, action) {
    return onApiError(dispatch, Object.assign({context: 'login'}, action));
}


function onLogOut(dispatch) {
    CMX.post('/me/logout')
        .then(() => dispatch({type: actions.AUTH_LOGOUT_SUCCESS}))
        .catch(error => onApiError(dispatch, {error}));
}

function renewAuthToken(action, getState, dispatch) {
    const state = getState();
    const args = {
        token: action.token,
        app_id: action.appId,
        fingerprint: getFingerprint(state)
    };
    
    CMX.post('/renewToken', args)
        .then(data => dispatch(loginPostSuccess(data)))
        .catch(error => dispatch(loginPostFailed(error)));
}


function onRegisterPost(getState, dispatch, action) {
    const state = getState();
    const isApple = state.auth.register === 'apple';
    let params = action.payload;
    
    if (('auth_pin' in action) && ('loyalty_card_number' in params)) {
        params.loyalty_account_link_pin = action.auth_pin;
    }

    addReferralToParams(params, REFERRAL_SCOPES.USER_SIGNUP);

    let path;

    if (isApple) {
        path = '/login';
        params = {
            apple_signin: params,
            fingerprint: getFingerprint(state)
        };
    } else {
        path = '/register';
    }

    CMX.post(path, params)
        .then(data => dispatch(registerPostSuccess(data)))
        .catch(error => dispatch(registerPostFailed(error, action)));
}

function onCheckoutPaymentSuccess(action, getState, dispatch) {
    if (action.context !== CHECKOUT_CONTEXT_SIGN_UP) {
        return;
    }

    dispatch(registerPostSuccess(getUserSignUpPaymentResult(getState())));
}

function onAuthClose() {
    if (document.location.pathname.match(/^\/(registro|login)/)) {
        setTimeout(() => document.location = '/', 1000);
    }
}